export const ASCII_ART_RAW = `


                                              ++++++++++*%%%%%@@@@@        @@@@@@@@@@@@@@@@@@@@@
                                            =====++*#@#=:----===---#@@@ @@%+++***************%@@
                                        ====+++++*@*--*+=--------==+-=%@#+*****************#%@@
                                ====++++++++****%*-=*---------------=+%+**************##*#%@@@
                        =-------     ++++*****#@--#-------===========%****************#%%@@@
                          =- ========++++++**#%:=+-----=+*%%@@%%*===@***********
                 ----------   ========+++***#@+-*---===#%@@    @@%+%+********
               --  --------------==+++++***##%-*---===*%@@       @@#*****************#%@@@@
               ===-===  =-----=====----=+**##%:#-=====*%@        @%**************##*#%@@@@
                     =======-------=++*****##%-+=======#@@      @#*************#**#%@@@@@@
       -----------   -----------------==+++##@+-*=======+#@@@@@%%**********#*###%@@@@@@@@@
   ------------------------===+++****+++****##@==+============+@********#%%%%@@@@@
  -=      ========----===+========+++++****####@#=+====@@@@@@@@+%*******#% @@@@@
                ===========****+=====+****##%%%%%%#+=*++@@@@@@%#****##%    @@@@@
                        **********+++=====+%=%%@@@@@@#*+                @@@@@@@
                                                                        @@@@@@@                                

                                                                                                    `;

const CHAR_DENSITY: Record<string, number> = {
  '@': 1.0,
  '#': 0.9,
  '%': 0.85,
  '*': 0.7,
  '+': 0.55,
  '=': 0.45,
  '-': 0.3,
  ':': 0.2,
  '.': 0.1,
};

export interface VoxelData {
  col: number;
  row: number;
  density: number;
}

export function parseAsciiArt(): { grid: VoxelData[]; rows: number; cols: number } {
  const lines = ASCII_ART_RAW.split('\n').filter((l) => l.length > 0);
  const rows = lines.length;
  const cols = Math.max(...lines.map((l) => l.length));
  const grid: VoxelData[] = [];

  for (let r = 0; r < rows; r++) {
    const line = lines[r]!;
    for (let c = 0; c < line.length; c++) {
      const char = line[c]!;
      if (char === ' ') continue;
      const density = CHAR_DENSITY[char] ?? 0.4;
      grid.push({ col: c, row: r, density });
    }
  }

  return { grid, rows, cols };
}
